var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _line, _line2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 257,
    viewBox: "0 0 256 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4856 16.6188C51.7695 13.5309 54.3596 11.168 57.4605 11.168H116.033C119.617 11.168 122.401 14.2888 121.994 17.8492L121.774 19.7768C121.367 23.3372 124.152 26.4581 127.735 26.4581H229.384C232.894 26.4581 235.655 29.4582 235.363 32.9563L224.568 162.499C224.309 165.609 221.709 168.001 218.589 168.001H44.1471C40.6166 168.001 37.8492 164.967 38.1723 161.452L51.4856 16.6188Z",
    fill: "#F66DB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.683 106.84C227.167 110.217 248.137 127.177 248.137 168",
    stroke: "#E20074",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9492 106.84C26.212 109.686 8.73762 123.981 8.73762 158.389",
    stroke: "#E20074",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9314 53.0968C25.6127 49.5835 28.3791 46.5547 31.9069 46.5547H208.048C211.151 46.5547 213.743 48.9216 214.023 52.0126L223.953 161.46C224.271 164.973 221.505 168.002 217.977 168.002H41.8363C38.7327 168.002 36.1413 165.635 35.8609 162.544L25.9314 53.0968Z",
    fill: "#E20074"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.9834,
    cy: 93.7334,
    r: 11.3584,
    fill: "#121212"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.901,
    cy: 93.7334,
    r: 11.3584,
    fill: "#121212"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.662,
    cy: 99.4148,
    r: 2.1843,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.58,
    cy: 99.4148,
    rx: 3.05802,
    ry: 2.1843,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.4884,
    cy: 90.2398,
    rx: 5.24232,
    ry: 6.98976,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.406,
    cy: 90.2398,
    rx: 5.24232,
    ry: 6.98976,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.7,
    cy: 170.623,
    rx: 8.30034,
    ry: 12.2321,
    fill: "#E20074"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.437,
    cy: 236.15,
    rx: 103.099,
    ry: 14.8532,
    fill: "#F2F2F2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.825,
    cy: 230.659,
    rx: 8.30034,
    ry: 12.2321,
    transform: "rotate(-43.1136 163.825 230.659)",
    fill: "#E20074"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.30034,
    cy: 12.2321,
    rx: 8.30034,
    ry: 12.2321,
    transform: "matrix(-0.73 -0.683448 -0.683448 0.73 106.6 227.402)",
    fill: "#E20074"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.30034,
    cy: 12.2321,
    rx: 8.30034,
    ry: 12.2321,
    transform: "matrix(-1 0 0 1 16.6006 155.77)",
    fill: "#E20074"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 158.396,
    y1: 168,
    x2: 158.396,
    y2: 227.413,
    stroke: "#E20074",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 59.413,
    y2: -2,
    transform: "matrix(8.19589e-09 1 1 -2.33127e-07 99.6094 168)",
    stroke: "#E20074",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4883 133.49C103.39 122.423 129.835 106.929 156.396 133.49",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.aa685290f3c99e12ebc4f466e9c81f7b.svg";
export { ForwardRef as ReactComponent };